// @flow
import React from 'react';
import Banner from '../components/generic/banner';
import LinkTiles from '../components/home/linkTiles';
import ContactForm from '../components/generic/contactForm';
import Blocks from '../components/contact/blocks';
import { TextSection } from '../components/generic/text';

const Contact = () => (
  <main className="contact">
    <Banner
      heading="Get in touch"
      caption="Never hesitate to get in touch with us if you have any questions"
    />
    <Blocks />
    {/*<TextSection heading={'Request a demo'} />
    <ContactForm />*/}
    {/*<LinkTiles />*/}
  </main>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/contact.js